import { ICON__eye_slash_solid, ICON__eye_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { use_slice_ui, use_slice_user } from '@/hooks/store/use_slices';
import i18n_page_generation from '@/locales/keys/i18n_page_generation.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { FN_USER_SETTINGS__update } from '@/utils/utils_client';
import { DTO__user_settings } from '@shared/dto/+user/user_settings/DTO__user_settings';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  property: keyof DTO__user_settings;
}

export function G_BUTTON__hide_unused_values({ property }: Props) {
  /*
   * STORE
   */

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_GENERATION);

  const { user_settings } = use_slice_user(['user_settings']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  const tooltip_title = t(
    user_settings[property]
      ? i18n_page_generation.sidebar_settings.button.bar_hide_unused_values.tooltip.title_show
      : i18n_page_generation.sidebar_settings.button.bar_hide_unused_values.tooltip.title_hide,
  );

  const [is_loading, set_is_loading] = useState(false);

  /*
   * EVENTS
   */
  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let settings_new = user_settings.clone({ [property]: !user_settings[property] });

    set_is_loading(true);

    await FN_USER_SETTINGS__update(settings_new);

    set_is_loading(false);
  }

  /*
   * METHODS
   */
  function is_disabled() {
    return is_loading;
  }

  /*
   * HTML
   */

  return (
    <UI_PRIMITIVE__tooltip {...{ tooltip_title }}>
      <UI_PRIMITIVE__button_with_icon_animated
        variant={'no-border-on-bar'}
        size="rect-10-5"
        iconClassNameBase="text-component-item-foreground size-3"
        iconClassNameHovered="!text-bar-foreground"
        disabled={is_disabled()}
        {...{ onClick }}
        Icon={user_settings[property] ? ICON__eye_solid : ICON__eye_slash_solid}
      />
    </UI_PRIMITIVE__tooltip>
  );
}
